import(/* webpackMode: "eager" */ "/var/www/rentzeme/app/node_modules/next/dist/client/image-component.js");
